import { render, staticRenderFns } from "./CreateZohoChannel.vue?vue&type=template&id=3136129a&scoped=true"
import script from "./CreateZohoChannel.vue?vue&type=script&lang=js"
export * from "./CreateZohoChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateZohoChannel.vue?vue&type=style&index=0&id=3136129a&prod&lang=scss&scoped=true"
import style1 from "./CreateZohoChannel.vue?vue&type=style&index=1&id=3136129a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3136129a",
  null
  
)

export default component.exports